import { Span } from '@tblabs/truffle';
import { Row } from '../General/Row';
import { appendable } from '@tblabs/truffle/Core/appendable';


export class TitleRow extends Row
{
    constructor(title: string, ...components: appendable[])
    {
        super();

        this.TextAlignLeft().MarginBottom(8).Append(
            new Span(title).Class("title"),
            ...components
        );
    }
}
